module.exports = __webpack_public_path__ + "img/title-1.44a398ef.png";